<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Privacy Policy</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="privacy-policy">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="terms-and-conditions py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card shadow-lg border-0">
                    <div class="card-body ">
                        <h2 class="card-title text-center text-decoration-underline">Privacy Policy</h2>
                        <h5 class="text-decoration-underline">Welcome to ARNI University, Bringing Ambitions to
                            Life.</h5>

                        <p>We are available on the link https://arni.in/. We refer to ourselves as ‘Website, Us, We,’
                            and ‘You, Users or Visitors’ are used to refer to an individual, legal entity, or company
                            that accesses or runs our website.
                        </p>

                        <p>Your privacy is of utmost to us and we are committed to its respect. We do not sell, give,
                            share, or transfer any personal or crucial information to a third party. Through this
                            ‘Privacy Policy,’ we underline how we use, collect, and safeguard your personal information
                            when you visit our website or interact with us online. By accessing our website, you agree
                            to the terms of this Privacy Policy.
                        </p>

                        <h5 class="text-decoration-underline"><b>Browsing Behavior</b></h5>
                        <p>We monitor visitors' browsing habits to learn how our sites are being used. To improve user
                            experience, the websites employ Google Analytics to collect anonymous statistics.
                        </p>

                        <p>We can determine the following with the aid of the web operating system:
                        </p>
                        <ul>
                            <li>Your internet service's domain name, such as "abc.com" or "abc.net"</li>
                            <li>Which browser is being used—"Internet Explorer" or "Google Chrome"?</li>
                            <li>Which operating system—Windows, UNIX, or Macintosh—is being used?</li>
                            <li>When you last visited the website, what did you look at or click on, and how did you
                                find us
                            </li>
                            <li>No personal data is kept on file.</li>
                        </ul>

                        <h5 class="text-decoration-underline">Information We Collect</h5>
                        <p>To offer a seamless and best user experience, we may collect the following types of
                            information:</p>

                        <ul>
                            <li>
                                <p><b class="text-decoration-underline">Personal Information : </b> Name, email address,
                                    phone number, postal address, and
                                    other details provided when filling out forms or registering on our website. The
                                    purpose is to connect with our visitors and users.
                                </p>
                            </li>
                            <li>
                                <p><b class="text-decoration-underline">Usage Data : </b> Information about how you use
                                    our website, including IP address,
                                    browser type, pages viewed, and time spent on the website.
                                </p>
                            </li>
                            <li>
                                <p><b class="text-decoration-underline">Cookies and Tracking Technologies : </b>
                                    Cookies, web beacons, and similar
                                    technologies to enhance your browsing experience.
                                </p>
                            </li>
                            <li>
                                <p><b class="text-decoration-underline">Third-party Information : </b> Data from
                                    third-party services, such as social
                                    media platforms, if you interact with us through those services.
                                </p>
                            </li>
                        </ul>

                        <h5 class="text-decoration-underline">How We Use Your Information</h5>
                        <p>Our purpose in asking for personal information is to connect with our visitors and viewers
                            personally to:
                        </p>
                        <ul>
                            <li>Provide and improve our services.</li>
                            <li>Process inquiries, applications, or requests.</li>
                            <li>Communicate with you regarding updates, promotions, and events.</li>
                            <li>Personalize your experience on our website.</li>
                            <li>Analyze website usage to improve functionality.</li>
                            <li>Ensure compliance with legal obligations.</li>
                        </ul>

                        <h5 class="text-decoration-underline">Your Information Is Safe With Us</h5>
                        <p>Your data privacy and security are always being in our top priority. We use and implement
                            various security measures, including encryption of sensitive data, secure access controls to
                            limit unauthorized access and regular monitoring of our systems for vulnerabilities.</p>
                        <p><b>Note : </b> While we strive to protect your information, no transmission over the internet
                            is entirely secure. You share information at your own risk.
                        </p>
                        <h5 class="text-decoration-underline">Sharing of Information</h5>
                        <p>We do not rent or share your personal information with third parties. We may share your data
                            with:</p>

                        <ul>
                            <li>Vendors or contractors who help us manage and improve our website and services.
                            </li>
                            <li>Authorities or regulators if required to comply with legal obligations or protect our
                                rights.
                            </li>
                            <li>Entities involved in a merger, acquisition, or sale of ARNI University’s assets.
                            </li>
                        </ul>

                        <h5 class="text-decoration-underline">Cookies Policy</h5>
                        <p>ARNI university websites use essential cookies for interactive use, tracking users' activity.
                            Performance-enhancing cookies gather data about browser sessions, preventing repetitive
                            information input. Functional cookies allow websites to remember past decisions and provide
                            content based on user behavior, allowing for dynamic features and improved user experience.
                            These cookies are essential for navigating the website effectively.
                        </p>
                        <p><b> Note : </b> By using our website, you consent to our use of cookies. You can manage your
                            cookie preferences through your browser settings.
                        </p>

                        <h5 class="text-decoration-underline">Third-party Links</h5>
                        <p>Our website may contain links to third-party websites. ARNI University is not responsible for
                            the privacy practices or content of these websites. We encourage you to read their privacy
                            policies before sharing your information.
                        </p>
                        <h5 class="text-decoration-underline">Updates to This Privacy Policy</h5>
                        <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal
                            requirements. The updated version will be posted on our website with the "Last Updated"
                            date.
                        </p>
                        <h5 class="text-decoration-underline">Contact Us</h5>
                        <p>If you have questions or concerns about this Privacy Policy, please contact us:</p>
                        <p>ARNI University Website: arni.in, Email: <a href="mailto:info@arniuniversity.edu.in">info@arniuniversity.edu.in</a>,
                            and Phone: <a href="tel:18008918962">18008918962</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
